// 退款相关翻译

export const refund = {
    title: 'Request Refund',
    orderInfo: 'Order Information',
    conditionsTitle: 'Refund Conditions',
    reasonTitle: 'Refund Reason (Optional)',
    reasonPlaceholder: 'Please describe your reason for requesting a refund...',
    defaultReason: 'User requested refund',
    
    // 条件检查
    checkingConditions: 'Checking refund conditions...',
    checkFailed: 'Failed to check refund conditions',
    
    // 退款条件
    conditions: {
      isPaid: 'Order is paid',
      withinTimeLimit: 'Within 3-day refund period',
      hasEnoughCredits: 'Sufficient credit balance',
      passRiskControl: 'Passes risk control check',
      noPendingRefund: 'No pending refund requests',
      creditsDetails: 'Current: {{current}} credits, Required: {{required}} credits',
      riskDetails: 'Recent refunds: {{count}}/2 (30 days)'
    },
    
    // 退款说明
    notice: {
      title: 'Important Notice:',
      creditDeduction: 'Credits will be deducted immediately upon refund approval',
      processingTime: 'Refund processing takes 3-5 business days',
      irreversible: 'Refund requests cannot be cancelled once submitted'
    },
    
    // 按钮和状态
    confirm: 'Confirm',
    submitting: 'Submitting...',
    cannotRefund: 'Cannot Refund',
    
    // 消息
    successMessage: 'Refund request submitted successfully! Amount: {{amount}}, Refund ID: {{refundId}}',
    submitFailed: 'Failed to submit refund request'
  };
